import { Spacer, RadioButton } from '@adserve/adserve-react-components';
import React, { useContext, useState } from 'react';
import {
    cellPadding,
    labelStyle,
    descriptionContainerStyle,
    descriptionInputStyle,
    commercialPanelStyle
} from './CampaignBriefStyles';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';
import AsTextarea from '../../generic/AsTextArea';
import moment from 'moment';

const nameHeadingStyle = {
    fontFamily: 'Roboto',
    color: '#414141',
    fontSize: 14,
    fontWeight: 500
};

const radioTextStyle = {
    fontFamily: 'Roboto',
    color: '#414141',
    fontSize: 14,
    fontWeight: 500
};

const primaryHeadContainerStyle = {
    width: 174,
    height: 33,
    border: '1px solid #D7D7D7'
};

const secondaryHeadContainerStyle = {
    width: 87,
    height: 33,
    borderRight: '1px solid #D7D7D7'
};

const nameContainerStyle = {
    width: 324,
    height: 33,
    border: '1px solid #D7D7D7'
};

const smallTextHeadStyle = {
    fontFamily: 'Roboto',
    color: '#414141',
    fontSize: 13,
    fontWeight: 'bold'
};

const smallTextCellStyle = {
    fontFamily: 'Roboto',
    color: '#414141',
    fontSize: 13,
    fontWeight: 400
};

const PropertyVariances = ({
    campaign,
    updateCampaign,
    billingTerms,
    vats,
    deals,
    monthlyPoShowing,
    setMonthlyPoShowing,
    setCurrentDeal,
    setDealManuallySelected,
    readOnly = false,
    validJcn,
    setValidJcn,
    setBillingAccountId,
    readOnlyProperty,
    propertyTypes = []
}) => {
    const { propertyStats } = useContext(AirtimePlanningContext);
    const { formatCurrency, formatNumber } = useContext(SystemSettingsContext);
    const [displayField, setDisplayField] = useState('spotCount');

    console.log('variances properties: ', propertyStats);

    const handleChange = (event) => {
        const { name, value } = event.target;
        updateCampaign(name, value);
    };

    const getDisplayVal = (selectedProperty = {}, givenField) => {
        const usedPropertyType = propertyTypes?.find((pt) => pt?.id === selectedProperty?.sandPPropertyTypeId);
        if (usedPropertyType?.shortCode === 'ON') {
            const momentStart = moment(campaign?.startDate);
            const momentEnd = moment(campaign?.endDate);

            if (momentStart?.day() < 1) {
                momentStart.subtract(1, 'weeks').day(1);
            }
            if (momentEnd?.day() < 1) {
                momentStart.subtract(1, 'weeks').day(1);
            }

            const calculatedNumWeeks = momentEnd?.diff(momentStart, 'week') + 1;
            return isNaN(selectedProperty[givenField] * calculatedNumWeeks)
                ? 0
                : selectedProperty[givenField] * calculatedNumWeeks;
        } else {
            return selectedProperty[givenField];
        }
    };

    const paddingRows = () => {
        const paddingRowContent = [];

        if (propertyStats?.length < 5) {
            for (let i = 0; i < 5 - propertyStats?.length; i++) {
                paddingRowContent.push(
                    <div style={{ display: 'flex', width: '100%', marginTop: -1 }}>
                        <Spacer width={42} height={0} />
                        <div
                            align='left'
                            style={{ ...nameContainerStyle, backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF' }}
                        ></div>
                        <div
                            align='center'
                            style={{
                                ...primaryHeadContainerStyle,
                                marginLeft: -1,
                                backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                            }}
                        >
                            <div style={{ display: 'flex' }}>
                                <div style={secondaryHeadContainerStyle}></div>
                                <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}></div>
                            </div>
                        </div>
                        <div
                            align='center'
                            style={{
                                ...primaryHeadContainerStyle,
                                marginLeft: -1,
                                backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                            }}
                        >
                            <div style={{ display: 'flex' }}>
                                <div style={secondaryHeadContainerStyle}></div>
                                <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}></div>
                            </div>
                        </div>
                        <div
                            align='center'
                            style={{
                                ...primaryHeadContainerStyle,
                                marginLeft: -1,
                                backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                            }}
                        >
                            <div style={{ display: 'flex' }}>
                                <div style={secondaryHeadContainerStyle}></div>
                                <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}></div>
                            </div>
                        </div>
                        <div
                            align='center'
                            style={{
                                ...primaryHeadContainerStyle,
                                marginLeft: -1,
                                backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                            }}
                        >
                            <div style={{ display: 'flex' }}>
                                <div style={secondaryHeadContainerStyle}></div>
                                <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}></div>
                            </div>
                        </div>
                        <div
                            align='center'
                            style={{
                                ...primaryHeadContainerStyle,
                                marginLeft: -1,
                                backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                            }}
                        >
                            <div style={{ display: 'flex' }}>
                                <div style={secondaryHeadContainerStyle}></div>
                                <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}></div>
                            </div>
                        </div>
                        <div
                            align='center'
                            style={{
                                ...primaryHeadContainerStyle,
                                marginLeft: -1,
                                backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                            }}
                        >
                            <div style={{ display: 'flex' }}>
                                <div style={secondaryHeadContainerStyle}></div>
                                <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}></div>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return paddingRowContent;
    };

    const getRevisedTotalValue = (selectedProperty) => {
        return (
            parseFloat(getRevisedScheduledValue(selectedProperty)) +
            parseFloat(getRevisedLiveValue(selectedProperty)) +
            parseFloat(getRevisedAirtimeValue(selectedProperty))
        )?.toFixed(0);
    };

    const getCatalogTotalValue = (selectedProperty) => {
        return (
            parseFloat(getCatalogScheduledValue(selectedProperty)) +
            parseFloat(getCatalogLiveValue(selectedProperty)) +
            parseFloat(getCatalogAirtimeValue(selectedProperty))
        )?.toFixed(0);
    };

    const getRevisedScheduledValue = (selectedProperty) => {
        return displayField === 'spotCount'
            ? selectedProperty?.scheduledSpotCount
            : selectedProperty?.scheduledImpacts?.toFixed(0);
    };
    const getCatalogScheduledValue = (selectedProperty) => {
        return displayField === 'spotCount'
            ? selectedProperty?.catalogScheduledSpotCount
            : selectedProperty?.catalogScheduledImpacts?.toFixed(0);
    };

    const getRevisedPrice = (selectedProperty) => {
        return (
            selectedProperty?.livePrice +
            selectedProperty?.partnerAirtimePrice +
            selectedProperty?.scheduledPrice +
            selectedProperty?.advertorialPrice +
            selectedProperty?.featurePrice
        );
    };
    const getCatalogPrice = (selectedProperty) => {
        return (
            selectedProperty?.catalogLivePrice +
            selectedProperty?.catalogPartnerAirtimePrice +
            selectedProperty?.catalogScheduledPrice +
            selectedProperty?.catalogAdvertorialPrice +
            selectedProperty?.catalogFeaturePrice
        );
    };

    const getRevisedLiveValue = (selectedProperty) => {
        return displayField === 'spotCount'
            ? selectedProperty?.liveSpotCount + selectedProperty?.featureCount
            : (selectedProperty?.liveImpacts + selectedProperty?.featureImpacts)?.toFixed(0);
    };
    const getCatalogLiveValue = (selectedProperty) => {
        return displayField === 'spotCount'
            ? selectedProperty?.catalogLiveSpotCount + selectedProperty?.catalogFeatureCount
            : (selectedProperty?.catalogLiveImpacts + selectedProperty?.catalogFeatureImpacts)?.toFixed(0);
    };

    const getRevisedAirtimeValue = (selectedProperty) => {
        return displayField === 'spotCount'
            ? selectedProperty?.partnerAirtimeCount
            : selectedProperty?.partnerAirtimeImpacts?.toFixed(0);
    };
    const getCatalogAirtimeValue = (selectedProperty) => {
        return displayField === 'spotCount'
            ? selectedProperty?.catalogPartnerAirtimeCount
            : selectedProperty?.catalogPartnerAirtimeImpacts?.toFixed(0);
    };

    return (
        <div style={commercialPanelStyle}>
            <span style={{ fontSize: 15, fontWeight: 500, paddingLeft: 42 }}>
                {`${window.translate('Property Variances')}`}
            </span>

            {/* Radio Buttons Start*/}
            <div style={{ display: 'flex', width: '100%', marginTop: 13 }}>
                <Spacer width={42} height={0} />
                <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => setDisplayField('spotCount')}>
                    <RadioButton width={16} height={16} value={displayField === 'spotCount'} />
                    <Spacer width={5} height={0} />
                    <div style={{ marginTop: 6 }}>
                        <span style={radioTextStyle}>{window.translate('Spots')}</span>
                    </div>
                </div>
                <Spacer width={11} height={0} />
                <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => setDisplayField('impacts')}>
                    <RadioButton width={16} height={16} value={displayField === 'impacts'} />
                    <Spacer width={5} height={0} />
                    <div style={{ marginTop: 6 }}>
                        <span style={radioTextStyle}>{window.translate('Impacts')}</span>
                    </div>
                </div>
                {/* Radio Buttons End*/}
                <Spacer width={186} height={0} />

                {/* Top Header Row Start */}
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ paddingTop: 6 }}>
                        <span style={smallTextHeadStyle}>{window.translate('Scheduled Content')}</span>
                    </div>
                </div>
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ paddingTop: 6 }}>
                        <span style={smallTextHeadStyle}>{window.translate('Live Content')}</span>
                    </div>
                </div>
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ paddingTop: 6 }}>
                        <span style={smallTextHeadStyle}>{window.translate('Partner Airtime')}</span>
                    </div>
                </div>
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ paddingTop: 6 }}>
                        <span style={smallTextHeadStyle}>
                            {window.translate(`Total ${displayField === 'spotCount' ? 'Spots' : 'Impacts'}`)}
                        </span>
                    </div>
                </div>
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ paddingTop: 6 }}>
                        <span style={smallTextHeadStyle}>
                            {window.translate(`Value of ${displayField === 'spotCount' ? 'Spots' : 'Impacts'}`)}
                        </span>
                    </div>
                </div>
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ paddingTop: 6 }}>
                        <span style={smallTextHeadStyle}>{window.translate('Off-air Costs')}</span>
                    </div>
                </div>
                {/* Top Header Row End */}
            </div>

            <div style={{ display: 'flex', width: '100%', marginTop: -1 }}>
                <Spacer width={42} height={0} />
                <div align='left' style={nameContainerStyle}>
                    <div style={{ paddingTop: 6, paddingLeft: 8 }}>
                        <span style={nameHeadingStyle}>{window.translate('Property Name')}</span>
                    </div>
                </div>

                {/* Second Header Row Start */}
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ display: 'flex' }}>
                        <div style={secondaryHeadContainerStyle}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Catalog')}</span>
                            </div>
                        </div>
                        <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Revised')}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ display: 'flex' }}>
                        <div style={secondaryHeadContainerStyle}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Catalog')}</span>
                            </div>
                        </div>
                        <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Revised')}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ display: 'flex' }}>
                        <div style={secondaryHeadContainerStyle}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Catalog')}</span>
                            </div>
                        </div>
                        <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Revised')}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ display: 'flex' }}>
                        <div style={secondaryHeadContainerStyle}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Catalog')}</span>
                            </div>
                        </div>
                        <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Revised')}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ display: 'flex' }}>
                        <div style={secondaryHeadContainerStyle}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Catalog')}</span>
                            </div>
                        </div>
                        <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Revised')}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div align='center' style={{ ...primaryHeadContainerStyle, marginLeft: -1 }}>
                    <div style={{ display: 'flex' }}>
                        <div style={secondaryHeadContainerStyle}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Deal')}</span>
                            </div>
                        </div>
                        <div style={{ ...secondaryHeadContainerStyle, borderRight: 'none' }}>
                            <div style={{ paddingTop: 6 }}>
                                <span style={smallTextHeadStyle}>{window.translate('Revised')}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Second Header Row End */}
            </div>

            {propertyStats?.map((selectedProperty, j) => (
                <div key={`selected-property-variance-${j}`} style={{ display: 'flex', width: '100%', marginTop: -1 }}>
                    <Spacer width={42} height={0} />
                    <div
                        align='left'
                        style={{ ...nameContainerStyle, backgroundColor: j % 2 === 0 ? '#F7F7F7' : '#FFFFFF' }}
                    >
                        <div style={{ paddingLeft: 8, paddingTop: 5 }}>
                            <span style={{ ...smallTextCellStyle, fontSize: 14, fontWeight: 500 }}>
                                {selectedProperty?.name}
                            </span>
                        </div>
                    </div>
                    <div
                        align='center'
                        style={{
                            ...primaryHeadContainerStyle,
                            marginLeft: -1,
                            backgroundColor: j % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                        }}
                    >
                        <div style={{ display: 'flex' }}>
                            <div align='right' style={secondaryHeadContainerStyle}>
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>
                                        {getCatalogScheduledValue(selectedProperty, 'catalogScheduledContent')}
                                    </span>
                                </div>
                            </div>
                            <div
                                align='right'
                                style={{
                                    ...secondaryHeadContainerStyle,
                                    borderRight: 'none',
                                    ...(getRevisedScheduledValue(selectedProperty, 'catalogScheduledContent') !== getCatalogScheduledValue(selectedProperty, 'catalogScheduledContent')
                                        ? { backgroundColor: '#F2D0D0' }
                                        : {})
                                }}
                            >
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>
                                        {getRevisedScheduledValue(selectedProperty, 'catalogScheduledContent')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        align='center'
                        style={{
                            ...primaryHeadContainerStyle,
                            marginLeft: -1,
                            backgroundColor: j % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                        }}
                    >
                        <div style={{ display: 'flex' }}>
                            <div align='right' style={secondaryHeadContainerStyle}>
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>
                                        {getCatalogLiveValue(selectedProperty, 'catalogScheduledContent')}
                                    </span>
                                </div>
                            </div>
                            <div
                                align='right'
                                style={{
                                    ...secondaryHeadContainerStyle,
                                    borderRight: 'none',
                                    ...(getRevisedLiveValue(selectedProperty, 'catalogScheduledContent') !== getCatalogLiveValue(selectedProperty, 'catalogScheduledContent')
                                        ? { backgroundColor: '#F2D0D0' }
                                        : {})
                                }}
                            >
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>
                                        {getRevisedLiveValue(selectedProperty, 'catalogScheduledContent')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        align='center'
                        style={{
                            ...primaryHeadContainerStyle,
                            marginLeft: -1,
                            backgroundColor: j % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                        }}
                    >
                        <div style={{ display: 'flex' }}>
                            <div align='right' style={secondaryHeadContainerStyle}>
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>
                                        {getCatalogAirtimeValue(selectedProperty, 'catalogScheduledContent')}
                                    </span>
                                </div>
                            </div>
                            <div
                                align='right'
                                style={{
                                    ...secondaryHeadContainerStyle,
                                    borderRight: 'none',
                                    ...(getRevisedAirtimeValue(selectedProperty, 'catalogScheduledContent') !== getCatalogAirtimeValue(selectedProperty, 'catalogScheduledContent')
                                        ? { backgroundColor: '#F2D0D0' }
                                        : {})
                                }}
                            >
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>
                                        {getRevisedAirtimeValue(selectedProperty, 'catalogScheduledContent')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        align='center'
                        style={{
                            ...primaryHeadContainerStyle,
                            marginLeft: -1,
                            backgroundColor: j % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                        }}
                    >
                        <div style={{ display: 'flex' }}>
                            <div align='right' style={secondaryHeadContainerStyle}>
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>{getCatalogTotalValue(selectedProperty)}</span>
                                </div>
                            </div>
                            <div
                                align='right'
                                style={{
                                    ...secondaryHeadContainerStyle,
                                    borderRight: 'none',
                                    ...(getRevisedTotalValue(selectedProperty) !== getCatalogTotalValue(selectedProperty)
                                        ? { backgroundColor: '#F2D0D0' }
                                        : {})
                                }}
                            >
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>{getRevisedTotalValue(selectedProperty)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        align='center'
                        style={{
                            ...primaryHeadContainerStyle,
                            marginLeft: -1,
                            backgroundColor: j % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                        }}
                    >
                        <div style={{ display: 'flex' }}>
                            <div align='right' style={secondaryHeadContainerStyle}>
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>
                                        {formatCurrency(getCatalogPrice(selectedProperty, 'catalogTotalCost'))}
                                    </span>
                                </div>
                            </div>
                            <div
                                align='right'
                                style={{
                                    ...secondaryHeadContainerStyle,
                                    borderRight: 'none',
                                    ...(getRevisedPrice(selectedProperty, 'totalCost') !== getCatalogPrice(selectedProperty, 'catalogTotalCost')
                                        ? { backgroundColor: '#F2D0D0' }
                                        : {})
                                }}
                            >
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>
                                        {formatCurrency(getRevisedPrice(selectedProperty, 'totalCost'))}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        align='center'
                        style={{
                            ...primaryHeadContainerStyle,
                            marginLeft: -1,
                            backgroundColor: j % 2 === 0 ? '#F7F7F7' : '#FFFFFF'
                        }}
                    >
                        <div style={{ display: 'flex' }}>
                            <div align='right' style={secondaryHeadContainerStyle}>
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>
                                        {formatCurrency(getDisplayVal(selectedProperty, 'catalogOffAirCosts'))}
                                    </span>
                                </div>
                            </div>
                            <div
                                align='right'
                                style={{
                                    ...secondaryHeadContainerStyle,
                                    borderRight: 'none',
                                    ...(selectedProperty?.offAirCosts && selectedProperty?.offAirCosts !== selectedProperty?.catalogOffAirCosts
                                        ? { backgroundColor: '#F2D0D0' }
                                        : {})
                                }}
                            >
                                <div style={{ paddingRight: 8, paddingTop: 3 }}>
                                    <span style={smallTextCellStyle}>
                                        {formatCurrency(getDisplayVal(selectedProperty, 'offAirCosts'))}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            {paddingRows()}

            <Spacer width={0} height={13} />

            <div style={descriptionContainerStyle}>
                <div style={{ width: '100%', padding: cellPadding }}>
                    <AsTextarea
                        id='campaign-rationale'
                        name='rationale'
                        title={window.translate('Rationale *')}
                        labelStyle={labelStyle}
                        inputStyle={{
                            ...descriptionInputStyle,
                            border: `1px solid ${
                                propertyStats?.some((sp) => sp?.isModified === true)
                                    ? !campaign.rationale
                                        ? 'red'
                                        : 'green'
                                    : 'green'
                            }`
                        }}
                        value={campaign?.rationale}
                        onChange={handleChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default PropertyVariances;
